import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ModeSelectorComponent } from './mode-selector/mode-selector.component';
import { PageVideosComponent } from './page-videos/page-videos.component';
import { PageFaqComponent } from './page-faq/page-faq.component';

const routes: Routes = [
	{path: '' , component: ModeSelectorComponent},
	{path: 'learningmode', loadChildren: () => import('./learning-mode/learning-mode.module').then(m => m.LearningModeModule)},
	{path: 'productionmode', loadChildren: () => import('./production-mode/production-mode.module').then(m => m.ProductionModeModule)},
	{path: 'videos' , component: PageVideosComponent},
	{path: 'faq' , component: PageFaqComponent},
	{path: '*' , redirectTo: "" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
